import { recommended as commonRecommended } from '../common/after.js';

export const recommended = [...commonRecommended];
